import { useMutation } from '@tanstack/react-query';
import { makeRequest } from '../../data/makeRequest';

type CreateNewPinCodeRequest = {
	projectId: number;
	surveyId: string;
};

export const useCreateNewPinCodeMutation = () => {
	return useMutation({
		mutationFn: (data: CreateNewPinCodeRequest) =>
			makeRequest<{
				pinCode: string;
			}>({
				method: 'createNewPinCode',
				service: 'cde',
				data
			})
	});
};
